import { ColorPalette } from '../../../../../components/config';

// Shared horizontal metrics so the action-bar header columns line up with the
// per-citizen row columns (both must use identical margins and widths).
export const attendanceColumnMarginLeft = '24px';
// Fits name, caseworker and one status/comment line so toggling a registration doesn't change the row height.
export const citizenRowMinHeight = 96;
export const attendanceIconFontSize = 22;
export const attendanceNotRelevantIconFontSize = 21;
export const notRelevantColumnMarginLeft = '42px';
export const notRelevantColumnMinWidth = 112;
export const attendanceButtonColumnMinWidth = 92;
// Three status buttons per attendance column — a column without buttons must reserve the same width to stay aligned with the header.
export const attendanceColumnMinWidth = attendanceButtonColumnMinWidth * 4;

export const registeredStateLabelStyle = { fontSize: '0.6em', fontWeight: 600, color: ColorPalette.DisabledInputTextColor };
export const headerStateLabelStyle = { fontSize: '0.5em' };

// Overlays the label below the icon so it never affects layout — the icon stays centered whether a label is shown or not.
export const registeredStateLabelOverlayStyle = {
  ...registeredStateLabelStyle,
  position: 'absolute',
  top: '100%',
  left: '50%',
  transform: 'translateX(-50%)',
  whiteSpace: 'nowrap',
};
